import { render, staticRenderFns } from "./pageFujian1.vue?vue&type=template&id=1da98c5e&scoped=true"
import script from "./pageFujian1.vue?vue&type=script&lang=js"
export * from "./pageFujian1.vue?vue&type=script&lang=js"
import style0 from "./pageFujian1.vue?vue&type=style&index=0&id=1da98c5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da98c5e",
  null
  
)

export default component.exports